import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { toast } from "sonner";
import { escucharErrores, vigilarAvisos } from "@/lib/rastro";

// El rastro de fallos (lib/rastro): los avisos de error que ve el cliente y los errores
// de JavaScript que no recoge nadie.
vigilarAvisos(toast);
escucharErrores();

// FUERA LOS AVISOS VERDES (Enrique, 16-10): «Sesión cerrada», «Guardado»... ya no salen en
// ninguna pantalla. Se apagan aquí, de una vez, y no llamada por llamada.
// Y LOS AZULES TAMBIÉN (Enrique, 16-10, al guardar su primer postentreno): fuera todos los
// `toast.info`. Siguen los de error y los de aviso.
// MENOS LOS DEL PAGO (Francisco, 16-10): el que vuelve de pagar sin sesión solo tiene ese
// aviso para saber que su pago llegó y qué hacer (PAG-09, 14-10). Esos llevan `{ siempre: true }`.
const avisoVerde = toast.success;
const avisoAzul = toast.info;
toast.success = (mensaje, opciones) => (opciones?.siempre ? avisoVerde(mensaje, opciones) : undefined);
toast.info = (mensaje, opciones) => (opciones?.siempre ? avisoAzul(mensaje, opciones) : undefined);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: registrar el service worker (solo fuera de localhost; en desarrollo
// molesta y no aporta). Hace la app instalable desde el navegador.
if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
